import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
import profileSlice from "./profileSlice";
import sessionSlice from "./sessionSlice";
import capabilitySlice from "../features/capabilities/capabilitySlice";

const rootReducer = combineReducers({
  auth: authSlice,
  profileSlice,
  session: sessionSlice,
  // What the member may do, from the server rather than a stored role string
  // (ECH-288).
  capabilities: capabilitySlice,
});

export const store = configureStore({
  reducer: rootReducer,
});
